var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "white",
    stroke: "#21A6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9C13.47 9 9 13.47 9 19C9 24.53 13.47 29 19 29C24.53 29 29 24.53 29 19C29 13.47 24.53 9 19 9ZM24 22.59L22.59 24L19 20.41L15.41 24L14 22.59L17.59 19L14 15.41L15.41 14L19 17.59L22.59 14L24 15.41L20.41 19L24 22.59Z",
    fill: "#21A6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon17);
export default __webpack_public_path__ + "static/media/icon17.637868894abe4d21af0c917a8e3a2990.svg";
export { ForwardRef as ReactComponent };